export default __webpack_public_path__ + "static/media/arken-01.ca496177.png";